<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
      <!------------------------search---------------------->
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
            <el-form-item style="width:10%">
                <el-select v-model="query.income" placeholder="按收支" style="width:100%" clearable @change="ischange=true">
              	    <el-option v-for="(item,index) in incomeArr" :label="item.name" :value="item.id" :key="index"></el-option>
                </el-select>
            </el-form-item>
            <!--
            <el-form-item style="width:10%">
                <el-select v-model="query.type" placeholder="按类型" style="width:100%" clearable>
              	    <el-option v-for="(item,index) in typelist" :label="item.name" :value="item.name" :key="index"></el-option>
                </el-select>
            </el-form-item>
            -->

            <el-form-item style="width:21%">
            	<el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false" style="width:100%" clearable @change="ischange=true"></el-date-picker>
            </el-form-item>
            <el-form-item style="width:9%">
              <el-select v-model="query.clerkid" @change="ischange=true" clearable filterable placeholder="请选销售员" style="width:100%">
                  <el-option v-for="(item,index) in sellerLists" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item style="width:10%">
                <el-select v-model="query.applyid" placeholder="按供应商" @change="ischange=true" style="width:100%" clearable>
              	    <el-option v-for="(item,index) in allapplylists" :label="item.apply_name" :value="item.id" :key="index"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item size="small" style="width:12%">
              <el-select v-model="query.customerid" clearable filterable remote reserve-keyword :remote-method="getCustomer" :loading="customerLoading" @change="ischange=true" placeholder="客户名称 / 简称 / 客户手机" style="width:100%">
                    <el-option v-for="(item,index) in customerLists" :key="index" :label="item.showname" :value="item.id"></el-option>
                </el-select> 
            </el-form-item>

            <el-form-item ref="query" :model="query" style="width:15%">
            	<el-input placeholder="请输入关键字" v-model="query.key" @keyup.enter.native="getList" style="width:100%" clearable @change="ischange=true"></el-input>
            </el-form-item>
            <el-form-item>
            	<el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
              <el-button type="success" icon="el-icon-download" @click="exportgetList">导出</el-button>
            </el-form-item>
        </el-form>
        <!------------------------search end---------------------->

        <el-tag type='danger' style="margin-top:10px">温馨提示：销售出库相关的流水信息里展示的是客户名称，进货入库相关的流水信息里展示的供应商名称</el-tag>
        
        <div class="backborder2" style="margin-top:10px">
	        <el-table :data="lists" v-loading="listLoading">
	            <el-table-column prop="name" label="名称"></el-table-column>
              <el-table-column prop="customername" label="客户/供应商名称" width="150"></el-table-column>
              <el-table-column prop="clerkname" label="销售员名称" width="120" align="center"></el-table-column>
	            <el-table-column prop="amount" label="费用" width="150" align="center"></el-table-column>
	            <el-table-column prop="accountname" label="银行帐户" width="150" align="center"></el-table-column>
	            <el-table-column prop="paydate" label="支付日期" width="150" align="center"></el-table-column>
	            <el-table-column prop="type" label="类型" width="80" align="center">
		            <template slot-scope="scope">
		            	<el-tag v-if="scope.row.type=='销售'">{{scope.row.type}}</el-tag>
		            	<el-tag type="danger" v-if="scope.row.type=='进货'">{{scope.row.type}}</el-tag>
		            	<el-tag type="warning" v-if="scope.row.type=='退货'">{{scope.row.type}}</el-tag>
		            	<el-tag type="warning" v-if="scope.row.type=='反审'">{{scope.row.type}}</el-tag>
		            </template>
	            </el-table-column>
              <el-table-column prop="desc" label="备注" width="130" align="center"></el-table-column>
	        </el-table>
	        <div class="block">
	        <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>
        </div>

        <!-- 导出流水信息 -->
        <el-dialog title="导出流水信息确认" :visible.sync="exportDialog" width="98%" top="5vh">
	      	  <el-button size="medium" type="danger" @click="exportoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	  <div id="outputorder" style="float:left;width:100%;overflow:auto;">
		      	    <table border="0" cellspacing="0" cellpadding="0" class="tableshow1">
                    <tr>
                        <th align="left">编号</th>
                        <th align="left">名称</th>
                        <th align="left">客户名称/供应商名称</th>
                        <th align="left">销售员名称</th>
                        <th align="center">费用</th>
                        <th align="left">账户</th>
                        <th align="center">支付时间</th>
                        <th align="center">类型</th>
                        <th align="center">备注</th>
                    </tr>
                    <tr v-for="(item,index) in exportLists">
                        <td align="left">{{item.id}}</td>
                        <td align="left">{{item.name}}</td>
                        <td align="left">{{item.customername}}</td>
                        <td align="left">{{item.clerkname}}</td>
                        <td align="center">{{item.amount}}</td>
                        <td align="left">{{item.accountname}}</td>
                        <td align="center">{{item.paydate}}</td>
                        <td align="center">{{item.type}}</td>
                        <td align="left">{{item.desc}}</td>
                    </tr>
		   	        </table>
	      	  </div>
	      	  <div slot="footer" class="dialog-footer">
		            <el-button size="medium" @click="exportDialog=false" style="margin-top:20px">取 消</el-button>
		            <el-button size="medium" type="danger" @click="exportoutput" style="margin-top:20px">确认导出</el-button>
		        </div>	                
	      </el-dialog>

  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Fund/index",
      transitionshow:true,
      ischange:false,
      lists:[],
      listLoading:false,
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        income:'',
        type:'',
        date:[],
        clerkid:'',
        customerid:'',
        applyid:'',
        key:'',
        export: 0,
        rollpage: 10, // 页大小
        p: 1,
        isexport:1
      },
      total_rows: 0,
      brandlists:[],
      warehouselists:[],
      incomeArr:[{
        id:9,
        name:'收入'
      },{
        id:1,
        name:'支出'
      }],
      typelist:[{
        name:'销售'
      },{
        name:'进货'
      },{
        name:'退货'
      }],
      sellerLists:[],
      customerLoading:false,
      customerLists:[],
      allapplylists:[],
      exportDialog:false,
      exportLoading:false,
      exportLists:[],
    }
  },
  mounted(){
    this.getList();
    this.getSeller();
    this.getAllapplylists();
  },
  methods:{
    //信息列表
    getList(){
      this.listLoading=true;
      this.query.export=0;
      if(this.ischange==true) {
          this.query.p=1;
          this.query.rollpage=10;
      }

      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;
          if(this.ischange==true) this.ischange=false;

        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },

    /** 导出流水信息 **/
    exportgetList() {
        this.exportLoading=true;
        this.query.export=1;
        var resource = this.$resource(this.GLOBAL.exportUrl+'Fund/index');
        resource.query(this.query).then((res) => {
          if(res.data.Result>0){
            if(res.data.Result=='70001') this.$router.push('/login')
            this.$message.error(res.data.Message);
            this.exportLoading = false;
          }else{
            this.exportDialog=true;
            this.exportLists = JSON.parse(Base64.decode(res.data.Data));
            this.exportLoading = false;
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.exportLoading=false;
        });
    },
    
    /** 确认导出信息 **/
    exportoutput() {
        require.ensure([], () => {
            var { export_json_to_excel } = require('../../vendor/Export2Excel');
            var tHeader = ['编号','名称','客户名称/供应商名称','销售员名称','费用','账户','支付时间','类型','备注'];
            var filterVal = ['id','name','customername','clerkname','amount','accountname','paydate','type','desc'];
            
            var list = this.exportLists;
            var data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '退货记录');
            this.exportDialog=false;
        })
    },
    
    //导出表格数据
    formatJson(filterVal, jsonData) {
  　　　return jsonData.map(v => filterVal.map(j => v[j]));
  　},


    /** 获取销售员 **/
    getSeller(){
        var resource = this.$resource(this.GLOBAL.domain+"Clerk/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.sellerLists = JSON.parse(Base64.decode(res.data.Data));	                      
	        }
        }).catch((res) => {
            
        });
    },

    /** 获取客户 **/
    getCustomer(query){
        if (query !== '') {
	        this.customerLoading = true;
	        var resource = this.$resource(this.GLOBAL.domain+"Customer/index");
	        resource.query({act:'lists',key:query,token:this.$cookies.get('token')}).then((res) => {
	            if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		            this.customerLoading = false;
	            }else{
		            this.customerLists = JSON.parse(Base64.decode(res.data.Data));
		            this.customerLoading = false;
	            }
	        }).catch((res) => {
	            //this.$message.error(this.GLOBAL.errortext);
	            this.customerLoading = false;
	        });
        }
    },

    /** 获取全部供应商列表 **/
    getAllapplylists() {
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({act:'getapplyAll',token:this.$cookies.get('token')}).then((res) => {
        	if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login');
                this.$message.error(res.data.Message);;
            }else{
				        this.allapplylists=JSON.parse(Base64.decode(res.data.Data));
            }
        }).catch((res) => {
        	  //this.$message.error(this.GLOBAL.errortext);
        });
    },


  }
}
</script>
<style type="text/css">
.tableshow1 {width:100%;border:1px solid #ebeef5;color:#606266;border-collapse: collapse;}
.tableshow1 tr th,.tableshow1 tr td {width:auto;white-space:nowrap;border:1px solid #ebeef5;padding:10px 15px 10px 15px;font-size:14px;}
</style>


// WEBPACK FOOTER //
// src/components/stat/Fund.vue